import { render } from "./ProgramCreativity.vue?vue&type=template&id=673c17b2&scoped=true"
import script from "./ProgramCreativity.vue?vue&type=script&lang=js"
export * from "./ProgramCreativity.vue?vue&type=script&lang=js"

import "./ProgramCreativity.vue?vue&type=style&index=0&id=673c17b2&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673c17b2"]])

export default __exports__